import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import _ from 'lodash';

export default function getAllOtherProjectsReducer(state = initialState.allOtherProjects, action) {
	switch (action.type) {
		case types.GET_ALL_OTHER_PROJECTS: {
			return action.response;
		}		
		default:
			return state;
	}
}
